(function($, browserDetection) {

var JS_LAYOUT_SELECTOR = '.js-layout',
    JS_MOBILE_TOOLTIP_SELECTOR = '.js-mobile-tooltip',
    TOOLTIP_TIME_DELAY = 300,
    TOOLTIP_FADE_TIME = 100,
    TOOLTIP_OFFSET_X = 15,
    TOOLTIP_OFFSET_Y = 20,

    POPUP_OFFSET_X = 10,
    POPUP_OFFSET_Y = 10;

var hl_current_tooltip_id = '',
    isMobileMode = false,
    $body;

function getTooltipId(elem, prefix, id){
    var tooltip_id = '';

    var cls = elem.prop('className');
    var patt = /js-tooltip-id_([-\w]+)/;
    var result = patt.exec(cls);

    if (result && result.length > 0) {
        tooltip_id = result[1];
        return tooltip_id;
    }

    if (id != null)
        tooltip_id = id + prefix;
    else if (elem.prop('id') != '')
        tooltip_id = elem.prop('id') + prefix;

    return tooltip_id;
}

$(document).ready(function(){
    var isMobileBrowser = browserDetection.mobile,
        $document = $(document);

    $body = $('body');

    if (!isMobileBrowser) {
        $document
            .on('mouseenter', '.js-tooltip, ' + JS_MOBILE_TOOLTIP_SELECTOR, tooltip)
            .on('mouseenter','.js-popup', popup);
    } else {
        ieMobileSlowTooltipFix();

        isMobileMode = true;
        $document
            .on('touchstart', JS_MOBILE_TOOLTIP_SELECTOR, tooltip)
            .on('touchstart','.js-popup', popup)
            .on('scroll', hideTooltipIfAboveMenu);
    }

    if (!$('#js-tooltip-container').length){
        $body.append('<div id="js-tooltip-container"></div>');
    }
});

function ieMobileSlowTooltipFix() {
    var $mobileTooltips = $(JS_MOBILE_TOOLTIP_SELECTOR);

    if ($.browser.iemobile && $mobileTooltips.length) {
        $mobileTooltips.css('msTouchAction', 'none');
        $body.css('msTouchAction', 'pan-y');
    }
}

function tooltip(event){
    tooltipBasic(event, {
        'popup': false,
        'target': this
    });
}

function popup(event){
    tooltipBasic(event, {
        'popup': true,
        'target': this
    });
}

function tooltipBind(target_obj, tooltip_obj)
{
     $(document).on('mouseenter', target_obj, function(event){
        tooltipBasic(event, {
            'popup': false,
            'tooltip': tooltip_obj,
            'target': this
        });
    });
    $(document).on('mouseenter', target_obj, function(event){
        tooltipBasic(event, {
            'popup': true,
            'tooltip': tooltip_obj,
            'target': this
        });
    });
}
function hideTooltipIfAboveMenu(){
    var $tooltipContainer = $('#js-tooltip-container');
    var $tooltip = $tooltipContainer.children().first();
    var $nav = $('.js-nav-submenu:visible');
    if ($tooltip.length && $nav.length){
        if ($tooltip[0].getBoundingClientRect().top < $nav[0].getBoundingClientRect().top + $nav.height()) {
            $tooltipContainer.empty();
        }
    }
}

function tooltipBasic(event, param)
{
    var url = param.url;
    var id = undefined;

    // do not spam with selectors
    var container = $('#js-tooltip-container');
    var target = $(param.target);

    if (url != null)
    {
        id = '';
        var strar = url.substring(0, id.lastIndexOf('?')).split('/');
        for (var idx in strar){
            if (strar[idx].length > 0)
                id = id + strar[idx] + '_';
        }

        id = id.substring(0, id.lastIndexOf('_'));
        param.id = id;
    }
    else if (param.id != null)
        id = param.id;
    else
        id = target.prop('id');

    if (param.popup == null)
        param.popup = false;

    var tooltip
    if(param.tooltip)
    {
        tooltip = param.tooltip;
    }else{
        var tooltip_name = getTooltipId(target, param.popup ? '_popup' : '_tooltip', id);
        var tooltip_id = '#' + tooltip_name;
        tooltip = $(tooltip_id).clone();
    }

    container.append(tooltip.detach());

    tooltip.hide();
    tooltip.css({'position': 'absolute'});

    if ( typeof(id) == 'string')
    {
        if (url == null)
        {
            url = "";
            var strar = id.split('_');
            for (id in strar)
                url = url + '/' + strar[id];

            if (param.popup)
                url = url + "/?info=popup";
            else
                url = url + "/?info=tooltip";
        }
    }
    else
        return;

    var show_tooltip = function(is_loaded)
    {
        if (hl_current_tooltip_id != "" && hl_current_tooltip_id != tooltip_id){
            $(hl_current_tooltip_id).fadeOut(0);
        }

        if ($(target).hasClass('js-tooltip-only-overflow') && target.get(0).offsetWidth >= target.get(0).scrollWidth) {
            return;
        }

        hl_current_tooltip_id = tooltip_id;

        if (!is_loaded && !isMobileMode) {
            tooltip
                .delay(TOOLTIP_TIME_DELAY)
                .fadeIn(TOOLTIP_FADE_TIME, function() {
                    tooltip.css('opacity', 1);
                });
        } else {
            tooltip.fadeIn(0, function() {
                tooltip.css('opacity', 1);
            });
        }

        var tip_size = { x: tooltip.innerWidth(), y: tooltip.innerHeight() + 15 };

        var set_position = function(event) {

            var $window  = $(window);
            var offset = {x: 0, y: 0};
            var pointer_coord = isMobileMode ? {x: event.originalEvent.touches[0].pageX, y: event.originalEvent.touches[0].pageY}:
                                       {x: event.pageX, y: event.pageY};

            var coord = {x: 0, y: 0}; // final cordinates where tooltip will be shown
            var scroll = {x: $window.scrollLeft(), y: $window.scrollTop()};
            var win_size = {x: $window.width(), y: $window.height()};

            if (param.popup) {
                offset = { x: POPUP_OFFSET_X, y: POPUP_OFFSET_Y };
            } else {
                offset = { x: TOOLTIP_OFFSET_X, y: TOOLTIP_OFFSET_Y };
            }

            var remainedWindowWidth = win_size.x - (tip_size.x + (offset.x * 2));
            var tooltipOffsetX = pointer_coord.x + offset.x;

            if (pointer_coord.x + tip_size.x + (offset.x * 2) > win_size.x + scroll.x) {
                coord.x = pointer_coord.x  - tip_size.x - (offset.x * 2);
                //necessary for stay tooltip in window edges
                if (coord.x < 0) {
                    coord.x = win_size.x - (tip_size.x + (offset.x * 2));
                } else if (remainedWindowWidth > tooltipOffsetX) {
                    coord.x = pointer_coord.x + offset.x;
                }
            } else {
                coord.x = pointer_coord.x + offset.x;
            }

            if (pointer_coord.y + tip_size.y + offset.y > win_size.y + scroll.y) {
                coord.y = pointer_coord.y - offset.y - tip_size.y;
            } else {
                coord.y = pointer_coord.y + offset.y;
            }

            tooltip.css({'left': coord.x, 'top': coord.y});
        };

        set_position(event);

        target.trigger('tooltipshow', [tooltip]);

        if (!param.popup)
        {
            if (!isMobileMode) {
                target.bind('mousemove', function(event){
                    set_position(event);
                });
            }
        }

        var leave = function(event)
        {
            tooltip.clearQueue();

            if (hl_current_tooltip_id == tooltip_id)
                hl_current_tooltip_id = "";

            if (param.popup)
            {
                tooltip.delay(200).fadeOut(0);

                tooltip.one('mouseenter', function(){
                    tooltip.clearQueue();
                });

                tooltip.one('mouseleave', function(){
                    tooltip.fadeOut(0);
                });
            }
            else
            {
                tooltip.fadeOut(0, function() {
                    tooltip.remove();
                });
            }

            if (!param.popup) {
                target.unbind('mousemove');
            }
        };

        if (!isMobileMode) {
            target.one('mouseleave', leave);
        } else {
            $(JS_LAYOUT_SELECTOR).one('touchstart', leave);
        }

        $(window).one('unload', leave);
    };

    if ( tooltip.length == 0 )
    {
        var html = "<div class='tooltip' id='" + tooltip_name + "' style='position:absolute;'></div>";
        var error_text = '<span style="color:#cd5c5c;font-weight:bold;">' + translate('TOOLTIP_DOES_NOT_FOUND') + '</span>';

        $().add(html).appendTo(container).hide();
        tooltip.text(translate('TOOLTIP_LOADING'));

        try
        {
            $.ajax({
                'type': 'get',
                'url': url,
                'success': function(data) {
                    if (data && data != '')
                        tooltip.html(data);
                    else
                        tooltip.html(error_text);

                    show_tooltip(true);
                },
                'error': function() {
                    tooltip.html(error_text);
                    show_tooltip(true);
                }
            });
        }
        catch(er)
        {
            tooltip.html(error_text);
            show_tooltip(true);
        }
    }
    else
        show_tooltip(false);
}

window.tooltipReset = function(){
    $('#js-tooltip-container').html('');
};

})(jQuery, BROWSER_DETECTION_MODULE);
